import { useGetProfile } from '@sunrise-ui/api-client';
import { ExpandableText } from '@sunrise-ui/primitives';
import React from 'react';

type Props = {
  userId?: string;
  charLimit?: number;
};

export function ProfileBio({ userId, charLimit = 250 }: Props) {
  const { data: profile } = useGetProfile(userId);

  return <ExpandableText text={profile?.bio} charLimit={charLimit} />;
}
